module.exports = __webpack_public_path__ + "static/media/opties.f6fecf25.svg";